



















import Vue from "vue";
import ExpandibleButton from "./ExpandibleToolButton.vue";
import {mapGetters} from "vuex";

export default Vue.extend({
  name: "SliderButton",
  components: {
    ExpandibleButton
  },
  computed: {
      ...mapGetters({
        size: 'getActiveToolSize'
      })
  }
});
